import { Controller } from "@hotwired/stimulus"

// Zet "onderaannemer" alvast op Ja zodra de klant op een aannemer lijkt: een
// KvK-nummer en een naam als hovenier, groen, tuin of aannemer. Wie zelf
// kiest, wint altijd.
export default class extends Controller {
  static targets = ["name", "kvk", "yes", "no", "hint", "fieldset"]

  touched() {
    this.chosen = true
    this.hintTarget.classList.add("hidden")
  }

  suggest() {
    if (this.chosen || !this.hasYesTarget) return

    const pattern = new RegExp(this.fieldsetTarget.dataset.pattern, "i")
    const likely = this.kvkTarget.value.trim() !== "" && pattern.test(this.nameTarget.value)
    this.yesTarget.checked = likely
    if (!likely) this.noTarget.checked = false
    this.hintTarget.classList.toggle("hidden", !likely)
  }
}
